import { Action } from 'redux';
import {
  Currency,
  CurrencyExchangeRates,
  DeliveryEta,
  DesignerFeatures,
  DraftConfigurationColor,
  PrintType,
  PrintTypesMap,
  Shop,
  SprdUser,
  StoreFontFamily,
  StoreSpecialFont,
} from '@/types';

export interface CoreState {
  context: Shop;
  currency: Currency;
  features: DesignerFeatures;
  fonts: StoreFontFamily[];
  specialFonts: StoreSpecialFont[];
  mementoCheckEnabled: boolean;
  exchangeRates: CurrencyExchangeRates;
  user?: SprdUser;
  deliveryEta: Record<string, DeliveryEta | null>;
  printTypes: PrintTypesMap;
  digitalColors: DraftConfigurationColor[];
}

export enum CoreActionTypes {
  FEATURES_SET = '@core/features/set',
  CURRENCY_FETCH = '@core/currency/fetch',
  CURRENCY_EXCHANGE_RATES_FETCH = '@core/currency-exchange-rates/fetch',
  CONTEXT_FETCH = '@core/context/fetch',
  FONTS_FETCH = '@core/fonts/fetch',
  SPECIAL_FONTS_FETCH = '@core/special-fonts/fetch',
  SET_FONT_LOADED = '@core/fonts/set-loaded',
  ENABLE_MEMENTO_CHECK = '@core/enable-memento-check',
  SET_USER = '@core/user/set',
  DELIVERY_ETA_FETCH = '@core/deliveryETA/fetch',
  PRINT_TYPE_FETCH = '@print-types/fetch',
}

export interface CurrencyExchangeRatesFetchAction extends Action {
  type: CoreActionTypes.CURRENCY_EXCHANGE_RATES_FETCH;
  payload: CurrencyExchangeRates;
}

export interface FeaturesSetAction extends Action {
  type: CoreActionTypes.FEATURES_SET;
  features: DesignerFeatures;
}

export interface CurrencyFetchAction extends Action {
  type: CoreActionTypes.CURRENCY_FETCH;
  currency: Currency;
}

export interface ContextFetchAction extends Action {
  type: CoreActionTypes.CONTEXT_FETCH;
  payload: Shop;
}

export interface FontsFetchAction extends Action {
  type: CoreActionTypes.FONTS_FETCH;
  payload: StoreFontFamily[];
}

export interface SpecialFontsFetchAction extends Action {
  type: CoreActionTypes.SPECIAL_FONTS_FETCH;
  payload: StoreSpecialFont[];
}

export interface SetFontLoadedAction extends Action {
  type: CoreActionTypes.SET_FONT_LOADED;
  identifier: string;
  supportedGlyphs: RegExp;
}

export interface EnableMementoCheckAction extends Action {
  type: CoreActionTypes.ENABLE_MEMENTO_CHECK;
}

export interface SetUserAction extends Action {
  type: CoreActionTypes.SET_USER;
  payload: SprdUser;
}

export interface FetchDeliveryETAAction extends Action {
  type: CoreActionTypes.DELIVERY_ETA_FETCH;
  id: string;
  payload: DeliveryEta | null;
}

export interface PrintTypeFetchAction {
  type: CoreActionTypes.PRINT_TYPE_FETCH;
  printTypes: PrintType[];
}

export type CoreAction =
  | FeaturesSetAction
  | CurrencyFetchAction
  | ContextFetchAction
  | FontsFetchAction
  | SpecialFontsFetchAction
  | SetFontLoadedAction
  | EnableMementoCheckAction
  | CurrencyExchangeRatesFetchAction
  | SetUserAction
  | FetchDeliveryETAAction
  | PrintTypeFetchAction;
